var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWithBlueBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#111D5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85433 7.25C9.85433 7.07741 9.99424 6.9375 10.1668 6.9375H11.8335C12.0061 6.9375 12.146 7.07741 12.146 7.25V7.5625H13.9168C14.0894 7.5625 14.2293 7.70241 14.2293 7.875C14.2293 8.04759 14.0894 8.1875 13.9168 8.1875H8.0835C7.91091 8.1875 7.771 8.04759 7.771 7.875C7.771 7.70241 7.91091 7.5625 8.0835 7.5625H9.85433V7.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60012 9.31033C8.61184 9.20482 8.70102 9.125 8.80718 9.125H13.1931C13.2993 9.125 13.3885 9.20482 13.4002 9.31033L13.4836 10.0609C13.6339 11.4138 13.6339 12.7792 13.4836 14.1321L13.4754 14.206C13.4206 14.6987 13.0388 15.0916 12.5478 15.1604C11.521 15.3041 10.4793 15.3041 9.45255 15.1604C8.96157 15.0916 8.57968 14.6987 8.52493 14.206L8.51672 14.1321C8.3664 12.7792 8.3664 11.4138 8.51672 10.0609L8.60012 9.31033ZM10.4793 10.75C10.4793 10.5774 10.3394 10.4375 10.1668 10.4375C9.99424 10.4375 9.85433 10.5774 9.85433 10.75L9.85433 13.6667C9.85433 13.8393 9.99424 13.9792 10.1668 13.9792C10.3394 13.9792 10.4793 13.8393 10.4793 13.6667L10.4793 10.75ZM12.146 10.75C12.146 10.5774 12.0061 10.4375 11.8335 10.4375C11.6609 10.4375 11.521 10.5774 11.521 10.75V13.6667C11.521 13.8393 11.6609 13.9792 11.8335 13.9792C12.0061 13.9792 12.146 13.8393 12.146 13.6667V10.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWithBlueBg);
export default __webpack_public_path__ + "static/media/DeleteWithBlueBg.c02953d3c1248b137dc427ac4baea28e.svg";
export { ForwardRef as ReactComponent };